export default "__VITE_ASSET__CrZYMovL__"